"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const usersLicence_1 = __importDefault(require("../api/usersLicence"));
const AuthProvider_1 = require("./AuthProvider");
const react_2 = require("@fluentui/react");
const react_components_1 = require("@fluentui/react-components");
const react_router_dom_1 = require("react-router-dom");
const react_icons_mdl2_1 = require("@fluentui/react-icons-mdl2");
const Dictionary_1 = require("../model/Dictionary");
let dataGridHeaderStyle = { fontWeight: "bold" };
const useStyles = (0, react_components_1.makeStyles)({
    soonExpire: {
        backgroundColor: "orange"
    },
    expired: {
        backgroundColor: "red"
    },
    validExpiration: {
        backgroundColor: "transparent"
    }
});
function compareTime(time) {
    let cT = Date.parse(time);
    let now = new Date().getTime();
    const OFFSET = 60 * 60 * 24 * 30 * 1000;
    if (cT > (now + OFFSET))
        return 0;
    if (cT <= (now + OFFSET) && cT > now)
        return 1;
    if (cT < now)
        return -1;
}
function getServiceOrFeatureLabel(key) {
    return Dictionary_1.SERVICE_DICT.get(key);
}
function renderServicesArray(srv) {
    return srv.map((item, index) => (react_1.default.createElement(react_1.default.Fragment, { key: index }, react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_icons_mdl2_1.CaretSolidRightIcon, null),
        react_1.default.createElement(react_components_1.Label, { style: { paddingLeft: "5px" } }, item.feature ? `${getServiceOrFeatureLabel(item.serviceId)} - ${getServiceOrFeatureLabel(item.feature)}` : `${getServiceOrFeatureLabel(item.serviceId)}`),
        react_1.default.createElement("br", null)))));
}
const UserList = () => {
    const styles = useStyles();
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const [userList, setUserList] = (0, react_1.useState)([]);
    const [selectedGroupName, setSelectedGroupName] = (0, react_1.useState)(searchParams.get("groupName"));
    const [groupNames, setGroupNames] = (0, react_1.useState)([]);
    const { user, logout } = (0, AuthProvider_1.useAuth)();
    const options = groupNames;
    const columns = [
        /*  hidden columns
                createTableColumn<User>({
                    columnId: "name",
                    compare: (a, b) => {
                        return a.firstName.localeCompare(b.firstName);
                    },
                    renderHeaderCell: () => {
                        return "Name";
                    },
                    renderCell: (item) => {
                        return <TableCellLayout>{item.firstName}</TableCellLayout>;
                    },
                }),
                createTableColumn<User>({
                    columnId: "lastName",
                    compare: (a, b) => {
                        return a.lastName.localeCompare(b.lastName);
                    },
                    renderHeaderCell: () => {
                        return "Last Name";
                    },
                    renderCell: (item) => {
                        return <TableCellLayout>{item.lastName}</TableCellLayout>;
                    },
                }), */
        (0, react_components_1.createTableColumn)({
            columnId: "email",
            compare: (a, b) => {
                return a.email.localeCompare(b.email);
            },
            renderHeaderCell: () => {
                return "Email";
            },
            renderCell: (item) => {
                return (react_1.default.createElement(react_components_1.TableCellLayout, null, item.email));
            },
        }),
        (0, react_components_1.createTableColumn)({
            columnId: "services",
            renderHeaderCell: () => {
                return "Services";
            },
            renderCell: (item) => {
                var _a;
                let srv = ((_a = item.licence) === null || _a === void 0 ? void 0 : _a.allowedServices) || [];
                return (react_1.default.createElement(react_components_1.TableCellLayout, null, renderServicesArray(srv)));
            },
        }),
        (0, react_components_1.createTableColumn)({
            columnId: "beginingDate",
            renderHeaderCell: () => {
                return "Begining Date";
            },
            renderCell: (item) => {
                var _a, _b;
                return (react_1.default.createElement(react_components_1.TableCellLayout, null, ((_a = item.licence) === null || _a === void 0 ? void 0 : _a.beginingDate) && new Date((_b = item.licence) === null || _b === void 0 ? void 0 : _b.beginingDate).toLocaleDateString()));
            },
        }),
        (0, react_components_1.createTableColumn)({
            columnId: "renewalDate",
            renderHeaderCell: () => {
                return "Renewal Date";
            },
            renderCell: (item) => {
                var _a, _b;
                return (react_1.default.createElement(react_components_1.TableCellLayout, null, ((_a = item.licence) === null || _a === void 0 ? void 0 : _a.renewalDate) && new Date((_b = item.licence) === null || _b === void 0 ? void 0 : _b.renewalDate).toLocaleDateString()));
            },
        }),
        (0, react_components_1.createTableColumn)({
            columnId: "expirationTime",
            renderHeaderCell: () => {
                return "Expiration Date";
            },
            renderCell: (item) => {
                var _a, _b, _c, _d, _f;
                let renderedClassName = (0, react_components_1.mergeClasses)(styles.validExpiration);
                if (compareTime((_a = item.licence) === null || _a === void 0 ? void 0 : _a.expirationTime) == -1)
                    renderedClassName = (0, react_components_1.mergeClasses)(styles.expired);
                else if (compareTime((_b = item.licence) === null || _b === void 0 ? void 0 : _b.expirationTime) == 1)
                    renderedClassName = (0, react_components_1.mergeClasses)(styles.soonExpire);
                else if (compareTime((_c = item.licence) === null || _c === void 0 ? void 0 : _c.expirationTime) == 0)
                    renderedClassName = (0, react_components_1.mergeClasses)(styles.validExpiration);
                return (react_1.default.createElement(react_components_1.TableCellLayout, { className: renderedClassName }, ((_d = item.licence) === null || _d === void 0 ? void 0 : _d.expirationTime) && new Date((_f = item.licence) === null || _f === void 0 ? void 0 : _f.expirationTime).toLocaleDateString()));
            },
        }),
        (0, react_components_1.createTableColumn)({
            columnId: "comment",
            renderHeaderCell: () => {
                return "Comments";
            },
            renderCell: (item) => {
                var _a;
                return (react_1.default.createElement(react_components_1.TableCellLayout, { style: { padding: "10px 10px 10px 10px" } },
                    react_1.default.createElement(react_2.TextField, { readOnly: true, multiline: true, resizable: false, value: (_a = item.licence) === null || _a === void 0 ? void 0 : _a.comment })));
            },
        }),
        (0, react_components_1.createTableColumn)({
            columnId: "actions",
            renderHeaderCell: () => {
                return "Actions";
            },
            renderCell: (item) => {
                function handleDeleteLicence() {
                    usersLicence_1.default.deleteUserLicence(user.access_token, item.id, item.licence.id)
                        .then(() => {
                        usersLicence_1.default.getUsersWithLicences(user.access_token, selectedGroupName !== null && selectedGroupName !== void 0 ? selectedGroupName : "JB").then(res => {
                            res.json()
                                .then(body => {
                                setUserList(body);
                            });
                        });
                    })
                        .catch(err => {
                        console.log(err);
                    });
                }
                return (react_1.default.createElement(react_components_1.TableCellLayout, null,
                    react_1.default.createElement(react_2.Stack, { horizontal: true, tokens: { childrenGap: 8 } },
                        react_1.default.createElement(react_router_dom_1.Link, { to: `/users/${item.id}/edit` },
                            react_1.default.createElement(react_components_1.Button, { icon: react_1.default.createElement(react_icons_mdl2_1.EditIcon, null) }, "Edit")),
                        react_1.default.createElement(react_components_1.Button, { icon: react_1.default.createElement(react_icons_mdl2_1.DeleteIcon, null), onClick: handleDeleteLicence }, "Delete"))));
            },
        }),
    ];
    (0, react_1.useEffect)(() => {
        usersLicence_1.default.getUsersGroups(user.access_token).then(res => {
            if (res.status == 401 || res.status == 403) {
                logout();
            }
            else if (res.status != 200) {
                console.log(res.statusText);
            }
            else {
                res.json()
                    .then(body => {
                    let gN = body.map((item) => {
                        return {
                            key: item.name,
                            text: item.name.toUpperCase()
                        };
                    });
                    setGroupNames(gN);
                });
            }
        });
    }, []);
    (0, react_1.useEffect)(() => {
        usersLicence_1.default.getUsersWithLicences(user.access_token, selectedGroupName !== null && selectedGroupName !== void 0 ? selectedGroupName : "JB").then(res => {
            if (res.status == 401 || res.status == 403) {
                logout();
            }
            else if (res.status != 200) {
                console.log(res.statusText);
            }
            else {
                res.json()
                    .then(body => {
                    setUserList(body);
                });
            }
        });
    }, [selectedGroupName]);
    const handleDropDownChange = (_e, selection) => {
        if (selection) {
            setSelectedGroupName(selection.key.toString() || "");
        }
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(react_2.Dropdown, { placeholder: 'Wybierz klienta', options: options, onChange: handleDropDownChange }),
        react_1.default.createElement("p", { style: { padding: "0 0 30px 0" } }),
        react_1.default.createElement(react_components_1.DataGrid, { items: userList, columns: columns, sortable: true, getRowId: (item) => item.id },
            react_1.default.createElement(react_components_1.DataGridHeader, null,
                react_1.default.createElement(react_components_1.DataGridRow, { style: { borderBottomStyle: "ridge" } }, ({ renderHeaderCell }) => (react_1.default.createElement(react_components_1.DataGridHeaderCell, { style: dataGridHeaderStyle }, renderHeaderCell())))),
            react_1.default.createElement(react_components_1.DataGridBody, null, ({ item, rowId }) => (react_1.default.createElement(react_components_1.DataGridRow, { key: rowId, style: { borderBottomStyle: "ridge" } }, ({ renderCell }) => (react_1.default.createElement(react_components_1.DataGridCell, null, renderCell(item)))))))));
};
exports.default = UserList;
